import { SmsRegistrationForm } from "../../organisms/form/SmsRegistrationForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { useSmsRegistration } from "./hook";

export const SmsRegistrationPage: React.FC = () => {
  const { handleSmsRegistration, handleResendSms } = useSmsRegistration();

  return (
    <CardTemplate title="SMS認証">
      <SmsRegistrationForm
        handleSubmit={handleSmsRegistration}
        handleResendSms={handleResendSms}
      />
    </CardTemplate>
  );
};
